<template>
  <div class="back-nav">
    <van-icon name="arrow-left" class="back-icon" @click="goBackHandler" />
    <div class="title">{{ title }}</div>
    <div class="placeholder"></div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter();
const emit = defineEmits('onGoBanckHandler');
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  isLink: {
    type: Boolean,
    default: false,
  },
});
const goBackHandler = () => {
  if (props.isLink) {
    emit('onGoBanckHandler');
  } else {
    router.go(-1);
  }
};
</script>

<style lang="scss" scoped>
.back-nav {
  width: 100vw;
  height: 100px;
  background: var(--brand-gradient);
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.18);
  color: #fff;
  position: sticky;
  top: 0;
  z-index: 10;
  .back-icon {
    font-size: 46px;
    color: #fff;
    padding: 6px;
  }
  .title {
    flex: 1;
    text-align: center;
    font-size: 34px;
    font-weight: 600;
    letter-spacing: 1px;
    color: #fff;
  }
  // 占位撑起标题居中
  .placeholder {
    width: 58px;
  }
}
</style>
